import { render, staticRenderFns } from "./FoodDistributionIvrCalls.vue?vue&type=template&id=7288d6e3&"
import script from "./FoodDistributionIvrCalls.vue?vue&type=script&lang=js&"
export * from "./FoodDistributionIvrCalls.vue?vue&type=script&lang=js&"
import style0 from "./FoodDistributionIvrCalls.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports